import { DefaultVideoComponentProps } from '@draft-js-plugins/video/lib/video/components/DefaultVideoComponent';
import * as React from 'react';

import { EmbeddedVideo } from '@/components/EmbeddedVideo';

export const VideoEditor: React.FC<DefaultVideoComponentProps> = ({
  blockProps,
}) => {
  return <EmbeddedVideo src={blockProps.src} />;
};
